var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"disabled":!!_vm.changes.find(function (ref) {
	var action = ref.action;
	var field = ref.field;
	var prev = ref.prev;

	return action === 'change' && field === 'major' && prev === _vm.major;
})}},on),[_c('v-icon',{attrs:{"left":""}},[_vm._v("fal fa-exchange")]),_vm._v(" Change ")],1)]}}]),model:{value:(_vm.menuActive),callback:function ($$v) {_vm.menuActive=$$v},expression:"menuActive"}},[_c('v-list',[_c('v-list-item',{on:{"click":function($event){return _vm.$emit('major')}}},[_c('v-list-item-title',[_vm._v("Change Major")])],1),_c('v-list-item',{attrs:{"disabled":_vm.availableAdvisors.filter(function (ref) {
	var value = ref.value;

	return !_vm.currentAdvisors.find(function (ref) {
	var v = ref.value;

	return v === value;
	});
}).length === 0},on:{"click":function($event){return _vm.$emit('advisor')}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Request Advisor Change")]),(_vm.availableAdvisors.filter(function (ref) {
	var value = ref.value;

	return !_vm.currentAdvisors.find(function (ref) {
	var v = ref.value;

	return v === value;
	});
}).length === 0)?_c('v-list-item-subtitle',[_vm._v("No other advisors available")]):_vm._e()],1)],1),_c('v-list-item',{attrs:{"disabled":!!_vm.changes.find(function (ref) {
	var m = ref.major;
	var field = ref.field;

	return _vm.major === m && ['major', 'concentration'].includes(field);
})},on:{"click":function($event){_vm.concDialog = true}}},[_c('v-list-item-title',[_vm._v("Change Concentrations")])],1)],1)],1),(_vm.availableConcentrations.length > 0)?_c('conc-dialog',{attrs:{"major":_vm.major,"current-concentrations":_vm.currentConcentrations,"primary-concentrations":_vm.primaryConcentrations},on:{"save":function (c) { return _vm.$emit('concentration', c); }},model:{value:(_vm.concDialog),callback:function ($$v) {_vm.concDialog=$$v},expression:"concDialog"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }